(function() {
  'use strict';

  angular.module('cfn').directive('cfnMultiReferenceBox', cfnMultiReferenceBox);

  function cfnMultiReferenceBox() {
    var template =
      '<div ' +
      'class="referenceBox">' +
      '   <table class="subElement">' +
      '       <tr>' +
      '           <td width="100%" nowrap="nowrap" style="">' +
      '{{nameField}}' +
      '           </td>' +
      '           <td>' +
      '               <cfn-select-multi-reference class="imgOnly open" result="result" title="{{title}}" type="{{type}}">' +
      '                   <img src="img/bicons/black/choose.png"/>' +
      '               </cfn-select-multi-reference>' +
      '       </td><td>' +
      '            <button type="button" class="btn imgOnly" ng-show="field!=undefined" ng-click="result({})">' +
      '               <img src="img/bicons/black/remove.png"/>' +
      '            </button>' +
      '       </td>' +
      '       </tr>' +
      '   </table>' +
      '</div>';

    return {
      restrict: 'E',
      scope: {
        nameField: '=',
        field: '=',
        resultFunc: '&',
        title: '@',
        type: '@'
      },
      template: template,
      link: link
    };

    function link(scope, element, attrs) {
      element.click(function(event) {
        if (!scope.readonly) {
          // if the element is no button in the first place, the element was a click on the background
          if (
            !(
              $(event.target).is(':button') ||
              $(event.target)
                .parent()
                .is(':button')
            )
          ) {
            ang.callAfter(function() {
              // we need to leave the angular scope because the click triggers an angular scope itself
              element.find('.open button:first').trigger('click');
            });
          }
        }
      });
      scope.result = function(ob) {
        scope.resultFunc()(ob);
      };
    }
  }
})();
